if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					// qty.addEventListener('input', debounce(e=>{
                    qty.addEventListener('change', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){
            console.log("1234566")
			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});
			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => {
					if ( response.ok ) {
						return fetch('?section_id=helper-cart')
					} else {
						throw new Error('Something went wrong');
					}
				})
				.then(response => response.text())
				.then(text => {
					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                        if(cartItems.querySelector('.proceed_checkout') != null){
                          let amount = cartItems.querySelector('.proceed_checkout').dataset.proceedAmount - elm.textContent;
                          if(amount > 0){
                            cartItems.querySelector('.proceed_checkout').style.display = 'flex';
                            cartItems.querySelector('.proceed_amount').textContent = amount;
                            document.getElementById("CheckOut").style.pointerEvents = "none";
                          }else{
                            cartItems.querySelector('.proceed_checkout').style.display = 'none';
                            document.getElementById("CheckOut").style.pointerEvents = "visible";
                          } 
                        }
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});
					if ( newQty != 0 && cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`) && newQty > parseInt(cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`).dataset.qty) ) {
						let alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.innerHTML = KROWN.settings.locales.cart_add_error.replace('{{ title }}', item.dataset.title);
						this.form.prepend(alert);
					}
                  
                    let cart_error = document.querySelector('#cart.cart__form .alert__icon');
                    if(cart_error != null){
                      cart_error.addEventListener('click', ()=>{
                        document.querySelector('#cart.cart__form .alert.alert--error').style.display = 'none';
                      });  
                    }
                  
					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);
                  checkCartDrawer()

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
                    // alert.innerHTML = '<span class="alert__icon"><svg width="7" height="8" viewBox="0 0 7 8" fill="none"><rect x="5.9751" y="0.818024" width="1" height="8" transform="rotate(45 5.9751 0.818024)" fill="white"></rect><rect x="6.68213" y="6.47488" width="1" height="8" transform="rotate(135 6.68213 6.47488)" fill="white"></rect></svg></span><span><strong>email</strong>&nbsp;is invalid</span>';
					alert.innerHTML = '<span class="alert__icon"><svg width="7" height="8" viewBox="0 0 7 8" fill="none"><rect x="5.9751" y="0.818024" width="1" height="8" transform="rotate(45 5.9751 0.818024)" fill="white"></rect><rect x="6.68213" y="6.47488" width="1" height="8" transform="rotate(135 6.68213 6.47488)" fill="white"></rect></svg></span><span>'+ KROWN.settings.locales.cart_general_error +'</span>';
                    // alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);

                    let cart_error = document.querySelector('#cart.cart__form .alert__icon');
                    if(cart_error != null){
                      cart_error.addEventListener('click', ()=>{
                        document.querySelector('#cart.cart__form .alert.alert--error').style.display = 'none';
                      });  
                    }
				})
				.finally(() => {
					this.form.classList.remove('processing');
                   //appjetty delivery date code start
           
                  if(typeof(dds_calendar)!= 'undefined' && dds_calendar.length != 0){
                    if($('.appjetty-ddm-cart-box').length==0){
                      $('.appjetty-ddm-cart-cal').append(dds_calendar);
                      DDM_Calendar_view.init();    
                    }
                  }  
                  //appjetty code end
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
          //appjetty delivery date code start
            var timearrays=['100','300','500','1000','2000','4000','6000','7000','8000','9000']
            $.each(timearrays, function( index, value ) {
              
              setTimeout(function() {
              if(typeof(dds_calendar)!= 'undefined' && dds_calendar.length != 0){
                if($('.appjetty-ddm-cart-box').length==0){
                  $('.appjetty-ddm-cart-cal').append(dds_calendar);
                  DDM_Calendar_view.init();    
                }
              }  
            },value);
            });

          //appjetty code end
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                if(cartItems.querySelector('.proceed_checkout') != null){
                  let amount = cartItems.querySelector('.proceed_checkout').dataset.proceedAmount - elm.textContent;
                  if(amount > 0){
                    cartItems.querySelector('.proceed_checkout').style.display = 'flex';
                    cartItems.querySelector('.proceed_amount').textContent = amount;
                    document.getElementById("CheckOut").style.pointerEvents = "none";
                  }else{
                    cartItems.querySelector('.proceed_checkout').style.display = 'none';
                    document.getElementById("CheckOut").style.pointerEvents = "visible";
                  } 
                }
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}
var checkoutButton = document.querySelector("#CheckOutDisableBtn");
var deliveryErrorMsg = checkoutButton.getAttribute('data-errormessage');

checkoutButton.addEventListener("click", (event) => {
    var deliveryInput = document.getElementById('dds_calendar');
    var errorEle = document.querySelectorAll('#deliveryCustomError');
    if(errorEle.length > 0){
        var newElement = document.createElement('div');
        newElement.setAttribute('id','deliveryCustomError');
        newElement.innerHTML = '<p>'+deliveryErrorMsg+'</p>';
        deliveryInput.style.borderColor = "rgb(255, 0, 0)";
        deliveryInput.insertAdjacentElement('afterend', newElement);
    }
});
var deliveryInputEle = document.querySelector("#dds_calendar");

deliveryInputEle.addEventListener("change", (event) => {
    var inputValue = deliveryInputEle.value;
    var errorElement = document.querySelectorAll('#deliveryCustomError');
    if(errorElement.length > 0){
      if(inputValue != '' || inputValue != null){
         // document.getElementById('deliveryCustomError').remove()
      }
    }
});